/**
* @author XuZiYu
* @date 2019/7/8
* @time 17:08
*/
<template>
    <div class="wrapper-submit-order">
        <ctl-header title="订单确认" :onBack="onBack"></ctl-header>
        <div class="user-info-model" >
            <div class="show">
                <div class="info">
                    <div class="user">
                        <span class="name">{{ userInfo.userName ? userInfo.userName : userInfo.petName }}</span>
                        <span class="phone">{{ userInfo.phone }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="order-info">
            <div class="goods-model">
                <div class="goods-img">
                    <img :src="detailData.picture" alt=""/>
                </div>
                <div class="goods-info">
                    <h2 class="show-ellipsis">{{ detailData.courseName }}</h2>
                    <div class="goods-price-num">
                        <span><b>¥{{ detailData.payConPrice ? detailData.payConPrice : detailData.payOrigPrice }}</b></span>
                        <span>x1</span>
                    </div>
                </div>
            </div>
            <div class="model">
                <span>支付方式</span>
                <span>在线支付</span>
            </div>
        </div>
        <div class="footer">
            <span class="money">
                合计 <b>¥{{ detailData.payConPrice ? detailData.payConPrice : detailData.payOrigPrice  }}</b>
            </span>
            <van-button :loading="loading" class="btn-submit" @click="submit">提交订单</van-button>
        </div>
        <ctl-dialog v-model="messageDialog" :loading="loading"/>
    </div>
</template>

<script>
import { Button, Icon, Stepper, Toast } from 'vant'
import dialog from '@/components/dialog/index.vue'

export default {
    name: 'submitOrder',
    components: {
        [Icon.name]: Icon,
        [Toast.name]: Toast,
        ctlDialog: dialog,
        [Button.name]: Button,
        [Stepper.name]: Stepper
    },
    data () {
        return {
            cityCode: '',
            courseId: '',
            source: '',
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            loading: false,
            headShow: '1',
            userInfo: {},
            detailData: {}
        }
    },
    methods: {
        // 返回
        onBack () {
            if (this.source === 'app') {
                this.$jsBridge.callBackHandler('returnLastPage')
                return
            }
            this.$router.back()
        },
        // 提交购买订单
        submit () {
            let data = {
                cityCode: this.cityCode,
                courseId: this.courseId,
                currentMoney: this.detailData.payConPrice ? this.detailData.payConPrice : this.detailData.payOrigPrice,
                currentUserId: this.userInfo.userId
            }

            this.loading = true
            this.$api.submitMicroCourseOrder(data).then(res => {
                this.loading = false
                // 正常支付流程
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 兼容ios
                        this.$jsBridge.callBackHandler('setApplePayType', { payType: 7 })
                        // 暴露支付回调方法
                        this.$jsBridge.registerHandler('payCallback', (v) => {
                            this.$router.replace({ name: 'payResult',
                                query: { result: v,
                                    flag: '1',
                                    headShow: this.headShow,
                                    close: '1',
                                    type: '10',
                                    id: res.result.orderId,
                                    courseId: this.courseId,
                                    source: this.source } })
                        })
                        // 唤起苹果支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result.orderId,
                            productId: this.detailData.productId
                        })
                        return
                    }

                    this.$router.replace({
                        name: 'pay',
                        query: {
                            payId: res.result.orderId,
                            money: this.detailData.payConPrice ? this.detailData.payConPrice : this.detailData.payOrigPrice,
                            type: '10',
                            headShow: this.headShow,
                            source: this.source,
                            courseId: this.courseId
                        }
                    })
                } else if (res.code === '701') {
                    // 错误状态码处理
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.$router.replace({
                                name: 'microCourseOrderDetail',
                                query: { id: res.result.orderId, headShow: '1', source: this.source }
                            })
                        },
                        title: '',
                        content: '您有微课订单未支付'
                    }
                } else if (res.code === '30006') {
                    // 错误状态码处理
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '查看我的课程',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.$router.replace({ name: 'microCourseMy', query: { source: this.source } })
                        },
                        title: '温馨提示',
                        content: res.message
                    }
                } else if (res.code === '30005') {
                    // 错误状态码处理
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '确定',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.onBack()
                        },
                        title: '',
                        content: res.message
                    }
                } else {
                    Toast(res.message)
                }
            })
        },
        // 获取数据
        getDetail () {
            let postData = {
                courseId: this.courseId,
                cityCode: this.cityCode
            }
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.immediateOpen(postData).then(res => {
                Toast.clear()
                if (res.code === '200' && res.status) {
                    this.detailData = res.result
                } else {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '确定',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.$router.back()
                        },
                        title: '',
                        content: res.message
                    }
                }
            })
        }
    },
    created () {
        // 设置基础数据
        let { id, cityCode, source } = this.$route.query
        this.source = source
        this.courseId = id
        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || cityCode

        // 重新获取app用户数据
        let userInfo = this.$jsBridge.callBackHandler('passUserInfo')
        this.userInfo = userInfo ? JSON.parse(userInfo) : {}

        this.getDetail()
    }
}
</script>
<style lang="scss" scoped>
.wrapper-submit-order {
    * {
        word-break: break-all;
    }
    background: #FAFAFA;
    height: 100vh;
}
.show-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}
.footer {
    border-top: 1px solid #eeeeee;
    background: #ffffff;
    height: 49px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;

    .money {
        text-align: center;
        flex: 1;
        font: 400 17px PingFangSC-Regular;
        color: rgba(51, 51, 51, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        b {
            color: #FF5050;
        }
    }

    .btn-submit {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        border: none;
        width: 150px;
        background: rgba(83, 203, 133, 1);
        font: 600 18px PingFangSC-Semibold;
        color: rgba(255, 255, 255, 1);
    }
}

.model {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 0;
    border-top: 1px solid #EEEEEE;
    box-sizing: border-box;

    span:nth-child(1) {
        font: 400 14px PingFangSC-Regular;
        color: rgba(102, 102, 102, 1);
    }

    span:nth-child(2) {
        font: 400 14px PingFangSC-Regular;
        color: rgba(51, 51, 51, 1);

        b {
            color: #FF5050;
            margin-left: 5px;
        }
    }
}

.num-model {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 0;
    border-top: 1px solid #EEEEEE;
    box-sizing: border-box;

    span:nth-child(1) {
        font: 400 14px PingFangSC-Regular;
        color: rgba(102, 102, 102, 1);
    }
}

.order-info {
    background: #ffffff;
    padding: 0 15px;

    .goods-model {
        display: flex;
        align-items: center;
        padding: 33px 0;
        background: #ffffff;

        .goods-img {
            width: 100px;
            height: 65px;
            overflow: hidden;
            display: flex;
            font-size: 0;
            align-items: center;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .goods-info {
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            height: 65px;
            margin-left: 15px;
            flex: 1;

            h2 {

                font: 400 15px PingFangSC-Regular;
                color: rgba(51, 51, 51, 1);
            }

            .other-name {
                display: inline-block;
                border-radius: 3px;
                padding: 0 10px;
                border: 1px solid #FF5050;
                font: 400 12px PingFangSC-Regular, PingFang SC;
                color: #FF5050;
            }

            .goods-price-num {
                display: flex;
                align-items: center;
                justify-content: space-between;

                span {
                    white-space: nowrap;
                }

                span:nth-child(1) {
                    font: 600 14px PingFangSC-Semibold;
                    color: #666666;

                    b {
                        color: #FF5050;
                    }
                }

                span:nth-child(2) {
                    font: 400 14px PingFangSC-Regular;
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
}
.user-info-model {
    background: #ffffff;
    margin-bottom: 10px;
    padding: 15px;

    .show {
        display: flex;
        align-items: center;
    }
    .info {
        flex: 1;

        .user {
            display: flex;
            align-items: flex-end;

            .name {
                font: 600 18px PingFangSC-Semibold;
                color: rgba(51, 51, 51, 1);
            }

            .phone {
                margin-left: 10px;
                font: 400 14px PingFangSC-Regular;
                color: rgba(51, 51, 51, 1);
            }
        }
    }
}
</style>
